/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Notifications_DeleteInputs */

const he_account_notifications_delete = /** @type {(inputs: Account_Notifications_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחק התראה`)
};

const en_account_notifications_delete = /** @type {(inputs: Account_Notifications_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete notification`)
};

/**
* | output |
* | --- |
* | "Delete notification" |
*
* @param {Account_Notifications_DeleteInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_notifications_delete = /** @type {((inputs?: Account_Notifications_DeleteInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Notifications_DeleteInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_notifications_delete(inputs)
	return en_account_notifications_delete(inputs)
});